import React, { FC } from 'react'

import Typography from '@mui/material/Typography'

interface EmptyDataProps {
	readonly children?: React.ReactNode
	readonly iconSlot?: React.ReactNode
	readonly title?: string
	readonly subTitle?: string
	readonly titleSx?: object
}

const EmptyData: FC<EmptyDataProps> = ({
	children,
	iconSlot,
	title,
	subTitle,
	titleSx,
}: EmptyDataProps) => {
	return (
		<>
			{iconSlot}

			<Typography
				variant={'h6'}
				component={'h4'}
				fontSize={'0.9375rem'}
				textAlign={'center'}
				sx={titleSx}
			>
				{title}
			</Typography>

			{subTitle && (
				<Typography paragraph textAlign={'center'}>
					{subTitle}
				</Typography>
			)}

			{children}
		</>
	)
}

export default EmptyData
